import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import colors from '@app/constants/colors';
import { ContainerWithLogo, Modal } from '@app/components';
import RouterConstants from '@app/constants/router';
import { loginUser, notifyUserNotSupported, setError } from '@app/actions/userActions';
import LoginForm from './LoginForm';

class Login extends React.Component {
  componentWillUnmount() {
    const { setError, notifyUserNotSupported } = this.props;
    notifyUserNotSupported(false);
    setError(null);
  }

  render() {
    const { loginUser, isNotSupportedModalVisible, notifyUserNotSupported } = this.props;

    return (
      <ContainerWithLogo titleLabel="signIn.title">
        <LoginFormContainer>
          <LoginForm onSubmit={loginUser} />
          <NotMember>
            <FormattedMessage id="signIn.notMember" />
          </NotMember>
          <StyledLink to={RouterConstants.SUBSCRIBE}>
            <FormattedMessage id="signIn.signup" />
          </StyledLink>
        </LoginFormContainer>
        <Modal
          show={isNotSupportedModalVisible}
          onHide={() => notifyUserNotSupported(false)}
        >
          <ModalMessage>
            <FormattedMessage id="signIn.notSupportedText" />
            &nbsp;
            <Link to={RouterConstants.SUBSCRIBE}>
              <FormattedMessage id="signIn.notSupportedLink" />
            </Link>
          </ModalMessage>
        </Modal>
      </ContainerWithLogo>
    );
  }
}

Login.propTypes = {
  notifyUserNotSupported: PropTypes.func.isRequired,
  isNotSupportedModalVisible: PropTypes.bool.isRequired,
  loginUser: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

const mapStateToProps = ({ user: { isNotSupportedModalVisible } }) => ({ isNotSupportedModalVisible });

const mapDispatchToProps = {
  notifyUserNotSupported,
  loginUser,
  setError,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);

const LoginFormContainer = styled.div`
  max-width: 520px;
  width: 100%;
  text-align: center;
  color: white;
  padding: 0 10px;
`;

const StyledLink = styled(Link)`
  text-decoration: underline;
  margin: 20px 0 30px;
  color: white;
  display: block;
`;

const NotMember = styled.span`
  margin: 30px 0 0;
  display: block;
`;

const ModalMessage = styled.span`
  color: ${colors.FLAMENKO};
  
  & a {
    color: ${colors.FLAMENKO};
    text-decoration: underline;
    
    &:active,
    &:focus,
    &:visited {
      color: ${colors.FLAMENKO};
    }
  }
`;
